import { createAsyncAction } from "typesafe-actions";
import {UserDto} from './users.dtos';

export const userActions = createAsyncAction(
    'GET_USER_REQUEST',
    'GET_USER_SUCCESS',
    'GET_USER_ERROR',
  )<string, UserDto, string>();
  
  export const usersActions = createAsyncAction(
    'GET_USERS_REQUEST',
    'GET_USERS_SUCCESS',
    'GET_USERS_ERROR',
  )<string, UserDto[], string>();
  
  export const updateUserActions = createAsyncAction(
    'UPDATE_USER_REQUEST',
    'UPDATE_USER_SUCCESS',
    'UPDATE_USER_ERROR',
  )<UserDto, UserDto, string>();
  
  export const createUserActions = createAsyncAction(
    'CREATE_USER_REQUEST',
    'CREATE_USER_SUCCESS',
    'CREATE_USER_ERROR',
  )<UserDto, UserDto, string>();